/**
 * DevExtreme (esm/ui/editor/ui.data_expression.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import DataExpressionMixin from "../../__internal/ui/editor/m_data_expression";
export default DataExpressionMixin;
